import PageMain from '../components/Navigation/PageMain/PageMain';
import { PhoneSettings } from '../components/Settings/PhoneSettings/PhoneSettings';

export function PhoneSettingsPage() {
    return (
        <PageMain pageTitle="StayInContact Phone Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <PhoneSettings />
                </div>
            </div>
        </PageMain>
    );
}
